// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerAccommodationAccount_Page__1lVFR"};